var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputFieldCpt',{attrs:{"model":_vm.model,"prop":_vm.prop,"type":"textarea","label":_vm.label,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"autofocus":_vm.autofocus,"autosize":{ minRows: _vm.minRows, maxRows: _vm.maxRows }}})}
var staticRenderFns = []

export { render, staticRenderFns }